import src from "IMAGE";
export default { src, width: 158, height: 44, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AGhoaFtlZWVVb29vYFtbW1BRPBtEZUQDV1hKLEpxcXFeADg4ODhDQ0M4dHR0ZFtbW1BQPhtEZUQDV0U0GTtiYmJSumIUFQeLCy0AAAAASUVORK5CYII="};
